import { render, staticRenderFns } from "./CreateNewDress.vue?vue&type=template&id=47dd013a&scoped=true&"
import script from "./CreateNewDress.vue?vue&type=script&lang=js&"
export * from "./CreateNewDress.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewDress.vue?vue&type=style&index=0&id=47dd013a&scoped=true&lang=css&"
import style1 from "./CreateNewDress.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dd013a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VImg,VTextField})
